import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { VisualProofSection } from '../components/VisualProofSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ContentSection } from '../components/ContentSection';
import { ProductVisualSection } from '../components/ProductVisualSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PricingSection } from '../components/PricingSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { ClosingSection } from '../components/ClosingSection';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { WhatsAppButton } from '../components/WhatsAppButton';
export function LandingPage() {
  return <main className="w-full min-h-screen bg-[#0b0b0b]" data-id="element-417">
      <HeroSection data-id="element-418" />
      <VisualProofSection data-id="element-419" />
      <ProblemSection data-id="element-420" />
      <SolutionSection data-id="element-421" />
      <ContentSection data-id="element-422" />
      <ProductVisualSection data-id="element-423" />
      <TestimonialsSection data-id="element-424" />
      <PricingSection data-id="element-425" />
      <GuaranteeSection data-id="element-426" />
      <ClosingSection data-id="element-427" />
      <SocialProofPopup data-id="element-428" />
      <WhatsAppButton data-id="element-429" />
    </main>;
}